import {empty} from '../Core/common';
import {modal} from "../UI/modal";
import Events from "../Core/Events";

import OrderAPi from '../Api/order-api';
import config from "../../Config/config";

const RBM = {isSend: true, error_from_card: false, init: false, state: {}};

const modalConfig = {
    'size': 'modal-dialog-centered',
    'title': '',
    'message': '',
    'footer': '',
    'header': function () {
        return `<div class="modal-header">
                <div class="s-lg-24 fs-sm-20 fs-18 lh-0_9 mb-0 fw-bl">${modalConfig.title}</div>
                ${modalConfig.closeBtm}
                <hr>
            </div>`;
    },
    'closeBtm': `<button class="btn-close position-absolute end-0 top-0 mt-10 me-10 border-0 p-0 ms-auto d-flex p-10 bg-transparent" data-bs-dismiss="modal"><i class="icon u_multiply fs-sm-24 fs-20 text-main"></i></button>`,
};

const data = new Map();
// data.set('user_data_user_family', {
//     input: () => document.querySelector('[name="user_data_user_family"]'),
//     value: () => document.querySelector('[name="user_data_user_family"]').value,
//     asserts: [
//         value => !empty(value)
//     ]
// });
// data.set('user_data_user_name', {
//     input: () => document.querySelector('[name="user_data_user_name"]'),
//     value: () => document.querySelector('[name="user_data_user_name"]').value,
//     asserts: [
//          value => !empty(value)
//     ]
// });
// data.set('user_data_user_patronymic', {
//     input: () => document.querySelector('[name="user_data_user_patronymic"]'),
//     value: () => document.querySelector('[name="user_data_user_patronymic"]').value,
//     asserts: [
//         value => !empty(value)
//     ]
// });
data.set('user_data', {
    input: () => document.querySelector('[name="user_data"]'),
    value: () => document.querySelector('[name="user_data"]').value,
    asserts: [
        function (value) {
            return String(value).length >= 2;
        },

    ]
});
data.set('phone', {
    input: () => document.querySelector('[name="phone"]'),
    value: () => document.querySelector('[name="phone"]').value,
    asserts:
        [
            function (value) {
                let str = (value).replace(/[^0-9]/g, '');
                return str.length > 10;
            }
        ]
});
data.set('email', {
    input: () => document.querySelector('[name="email"]'),
    value: () => document.querySelector('[name="email"]').value,
    asserts: [
        // function (value) {
        //     return !empty(value);
        // },
        // function (value) {
        //     let reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        //     return reg.test(value);
        // }
    ]
});

// data.set('file', {
//     input: () => document.querySelector('[name="file"]'),
//     value: () => {
//         let item = document.querySelector('[name="file"]');
//         if(item  && "file" === item.getAttribute("type")){
//             return item.files[0];
//         }
//         return  '';
//     },
//     asserts:[]
// });

data.set('delivery_variant', {
    input: () => document.querySelector('[name="delivery_variant"]'),
    value: () => document.querySelector('[name="delivery_variant"]').value,
    asserts: []
});

data.set('organization', {
    input: () => document.querySelector('[name="organization"]'),
    value: () => {
        let organization = document.querySelector('[name="organization"]');
        if (organization) {
            return document.querySelector('[name="organization"]').value;
        }
        return '';
    },
    asserts: [
        function () {
            return true;
        }
    ]
});

data.set('user_data_time_zone', {
    input: () => document.querySelector('[name="user_data_time_zone"]'),
    value: () => document.querySelector('[name="user_data_time_zone"]').value,
    asserts: []
});

data.set('promo', {
    input: () => document.querySelector('[name="promo"]'),
    value: () => document.querySelector('[name="promo"]').value,
    asserts: []
});

// data.set('index_to_address', {
//     input: () => document.querySelector('[name="index"]'),
//     value: () => document.querySelector('[name="index"]').value,
//     asserts: [
//         function (value) {
//             let deliveryVariant = data.get('delivery_variant');
//             if ([1, 9].includes(parseInt(deliveryVariant.value()))) {
//                 return true;
//             }
//             return !empty(value);
//         }
//     ]
// });

data.set('street', {
    input: () => document.querySelector('[name="street"]'),
    value: () => document.querySelector('[name="street"]').value,
    asserts: [
        function (value) {
            let deliveryVariant = data.get('delivery_variant');
            if ([1, 9].includes(parseInt(deliveryVariant.value()))) {
                return true;
            }
            return !empty(value);
        }
    ]
});

// data.set('house', {
//     input: () => document.querySelector('[name="house"]'),
//     value: () => document.querySelector('[name="house"]').value,
//     asserts: [
//         function (value) {
//             let deliveryVariant = data.get('delivery_variant');
//             if ([1, 9].includes(parseInt(deliveryVariant.value()))) {
//                 return true;
//             }
//             return !empty(value);
//         }
//     ]
// });
//
// data.set('apartment', {
//     input: () => document.querySelector('[name="apartment"]'),
//     value: () => document.querySelector('[name="apartment"]').value,
//     asserts: []
// });
data.set('file', {
    input: () => document.querySelector('[name="file"]'),
    value: () => {
        let item = document.querySelector('[name="file"]');
        if (item && "file" === item.getAttribute("type")) {
            return item.files[0];
        }
        return '';
    },
    asserts: []
});

data.set('address', {
    input: () => {
        return document.querySelector('[name="address"]:checked');
    },
    value: () => {
        return document.querySelector('[name="address"]:checked').value;
    },
    asserts: [
        function () {
            return true;
        }
    ]
});
data.set('payment_variant', {
    input: () => document.querySelector('[name="payment_variant"]:checked'),
    value: () => document.querySelector('[name="payment_variant"]:checked').value,
    asserts: []
});



export default class Order {
    constructor(events) {
        this.events = events || new Events();
        const send = this.sendCartOrder.bind(this);
        const sendPayment = document.querySelector("#send_payment");
        const js_send_payment = document.querySelector(".js_send_payment");
        if (sendPayment) {
            sendPayment.addEventListener('click', event => {
                event.preventDefault();
                event.stopPropagation();
                send(sendPayment);
            });

            if (js_send_payment) {
                js_send_payment.addEventListener('click',
                    () => {
                        if (sendPayment.disabled === false) {
                            sendPayment.dispatchEvent(new Event("click"));
                        }
                    });
            }
        }
    }

    sendCartOrder(btn) {
        let $this = this;
        btn.disabled = true;
        RBM.send_from_card_builder();

        if (!RBM.error_from_card) {
            const queryData = new FormData();

            data.forEach((obj, key) => {
                queryData.append(key, obj.value());
                //queryData[key] = obj.value();
            });
            document.querySelector('body').classList.add('preloader');
            OrderAPi.create(queryData)
                .then(e => e.json())
                .then(theResponse => {
                    if (!theResponse.error && theResponse.url) {
                        try{
                            ym(25258874,'reachGoal','lead');
                        }catch (e){}
                        document.querySelector('section.cart').innerHTML = `<section class="cart-page">
                        <div class="container">
                            <h1 class="fs-lg-32 fs-md-28 fs-24 fw-black mb-xxl-50 mb-lg-40 mb-20">Все заказы оформлены</h1>
                            <div class="fs-24 lh-1 fw-bold">Перейдите в
                                <a href="/catalog.html"  class="fw-regular text-main text-decoration-underline">каталог товаров</a>
                            </div>
                        </div>
                    </section>`;

                        $this.events.dispatch(config.listeners.basket.update, {count_1: 0, count_2: 0});
                        history.pushState(null, null, '/basket.html');
                        setTimeout(() => document.location.href = theResponse.url, 200);
                    } else {

                        let message = theResponse.message;

                        if (theResponse.url) {
                            let interval = setInterval(function () {
                                let $timerRedirect = document.querySelector('.timer_redirect');
                                if ($timerRedirect) {
                                    let time = parseInt($timerRedirect.innerHTML);
                                    $timerRedirect.innerHTML = (time - 1);
                                } else {
                                    clearInterval(interval);
                                }
                            }, 3000);

                            message = `<div class="text-center">${theResponse.message} <br> <div>
                                     <br><br>
                                    Вы будете автомитически перенаправлены на <a class="text-success" href="${theResponse.url}">страницу заказа</a><br>
                                    Через <span class="timer_redirect">15</span> секунд
                                </div></div>`;

                            setTimeout(function () {
                                clearInterval(interval);
                                $this.events.dispatch(config.listeners.basket.update, {count_1: 0, count_2: 0});
                                document.location.href = theResponse.url;
                            }, 15000);
                            let js_cart_container = document.querySelector('js_cart_container');
                            if (js_cart_container) {
                                js_cart_container.innerHTML = `<div class="container">
                                <h1 class="fs-md-35 fs-24 lh-1 fw-bold mb-50">Корзина пуста</h1>
                                <div class="fs-24 lh-1 fw-bold">Перейдите в <a href="/catalog.html" class="fw-regular text-main text-decoration-underline">каталог товаров</a></div>
                            </div>`;
                            }
                            $this.events.dispatch(config.listeners.basket.update, theResponse);
                        }
                        modalConfig.message = `<div class="fs-20 fw-rg modal-form">${message}</div>`;
                        modal(modalConfig);
                    }
                }).catch(() => {
                modalConfig.message = `<div class="fs-20 fw-rg modal-form">Обнаружена неизвестная ошибка<br>Обратитесь к администратору.</div>`;
                modal(modalConfig);
            }).finally(() => {
                btn.disabled = false;
                document.querySelector('body').classList.remove('preloader');
            });
        } else {
            btn.disabled = false;
        }
    }
}

export const init = events => new Order(events);

RBM.send_from_card_builder = function () {
    RBM.error_from_card = false;

    data.forEach((obj) => {

        try {
            const input = obj.input();

            const val = obj.value();
            if (!RBM.init && input) {
                input.addEventListener('focus', function () {
                    input.classList.remove('is-invalid');
                });
            }

            if (obj.asserts && input) {
                for (let assert of obj.asserts) {
                    if (!assert(val)) {
                        console.log(input);
                        input.classList.add('is-invalid');
                        RBM.error_from_card = true;
                        break;
                    }
                    input.classList.remove('is-invalid');
                }
            }
        } catch (e) {
            console.log(e);
            RBM.error_from_card = true;
        }
    });

    let firstErrorElement = document.querySelector('.is-invalid');

    if (firstErrorElement) {
        firstErrorElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center'
        });
        modalConfig.message = `<div class="fs-20 fw-rg modal-form">Необходимо заполнить обязательные поля</div>`;
        modal(modalConfig);
    }
    RBM.init = true;
};